import {Entity, repository} from 'aurelia-orm';

@repository(TargetTag)
export class TargetTag extends Entity {

    constructor(text: string, targetId: number) {
        super();
        this.text = text;
        this.targetId = targetId;
    }

    id: number;
    targetId: number;
    text: string;
}